import { WidgetFetchError } from '@homerunner-next/widget-core/runtime'

/**
 * Throw a status-carrying `WidgetFetchError` when a fetch `Response` isn't ok
 * (#740). Widget data fetches used to `throw new Error('Failed to fetch …')`,
 * which dropped the HTTP status — so a widget couldn't tell a 429 rate limit
 * from any other failure, and (because the status was gone) the shared retry
 * policy couldn't skip retrying a throttled request, leaving the widget
 * spinning. Preserving the status lets the widget show a rate-limit message and
 * fail fast instead.
 *
 * Usage: `const res = await fetch(url); await okOrThrow(res, 'Failed to fetch X')`.
 */
export async function okOrThrow(res: Response, message: string): Promise<Response> {
  if (!res.ok) {
    throw new WidgetFetchError(res.status, `${message} (HTTP ${res.status})`)
  }
  return res
}
